var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconCrosshairSimple = function SvgIconCrosshairSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M21.625 12a9.625 9.625 0 1 1-19.25 0 9.625 9.625 0 0 1 19.25 0M13 7.125V4.44A7.63 7.63 0 0 1 19.56 11h-2.685a1 1 0 1 0 0 2h2.685A7.63 7.63 0 0 1 13 19.56v-2.685a1 1 0 1 0-2 0v2.685A7.63 7.63 0 0 1 4.44 13h2.685a1 1 0 1 0 0-2H4.44A7.63 7.63 0 0 1 11 4.44v2.685a1 1 0 1 0 2 0",
    clipRule: "evenodd"
  })));
};
export default SvgIconCrosshairSimple;